import basicController from "servicestack/basic.controller.properties";
import ServiceBus from 'servicestack/service-bus'
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from 'ioc/resolve';

export default class RetailerFormsPromptController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		let $rootScope = resolve('$rootScope');
		$ctrl.request = {
			FormId: $ctrl.form.id,
			RefId: $ctrl.retailer.id,
			Email: $ctrl.email || $ctrl.retailer.email
		};
	}
	submit() {
		const $ctrl = this;
		$ctrl.bus.send('RequestFormSubmission.json', $ctrl.request).then(res => $ctrl.$close(res));
	}
}
